import { api } from './api'
import { toastStore } from './toasts'
import { CharacterFormData, CreatorFormData, ContactFormData } from '/common/types/form'

export const formStore = {
  async submitCreatorForm(data: CreatorFormData) {
    const res = await api.post('/form/creator', data)
    if (res.error) {
      toastStore.error(`Failed to submit form: ${res.error}`)
      return false
    }

    toastStore.success('Application submitted successfully!')
    return true
  },

  async submitCharacterForm(data: CharacterFormData) {
    const res = await api.post('/form/character', data)
    if (res.error) {
      toastStore.error(`Failed to submit form: ${res.error}`)
      return false
    }

    toastStore.success('Character submission received!')
    return true
  },

  async submitContactForm(data: ContactFormData) {
    const res = await api.post('/form/contact', data)
    if (res.error) {
      toastStore.error(`Failed to send message: ${res.error}`)
      return false
    }

    toastStore.success('Message sent successfully!')
    return true
  },
}
